module.exports = __webpack_public_path__ + "5acd79a1337253f8be607b128002a543.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/elevator.png
// module id = 546
// module chunks = 0